var materialInputs;

$(document).ready(function () {
    // The 'label' functionality that sits above the input fields
    materialInputs = new logicjs.inputsTyped({
        activeClass: 'value-added',
        parentTarget: '.form-field--anim',
        selectFocusClass: 'select-focused'
    });
});
